import { render, staticRenderFns } from "./PatientConnectTwo.vue?vue&type=template&id=810e61c6"
import script from "./PatientConnectTwo.vue?vue&type=script&lang=js"
export * from "./PatientConnectTwo.vue?vue&type=script&lang=js"
import style0 from "./PatientConnectTwo.vue?vue&type=style&index=0&id=810e61c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports